export default __webpack_public_path__ + "media/flags/kh-e985d18c.svg";